const calculateMarginFromSellPrice = (sellPrice, effectiveCost, fallback = 0) => {
  const sell = Number(sellPrice || 0);
  const cost = Number(effectiveCost || 0);
  if (!(sell > 0)) return Number(fallback || 0);
  return Number((((sell - cost) / sell) * 100).toFixed(2));
};

module.exports = {
  calculateMarginFromSellPrice,
};
